import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import theme from '../../../../../../assets/styles/theme/theme';
import { EMeasureUnit } from '../../../../../../store/commomTypes';
import { IMeasureUnit } from '../../../../../../store/ducks/long-steel-shopping-cart/types';
import { Chips } from '@gerdau/hefesto-mais-web';
import { TChipArray } from '@gerdau/hefesto-mais-web/Chips/Chips.types';
import { isSelectedAnInvalidMeasureUnit } from '../shoppingCartFieldsValidation';

interface IUnitSelectProps {
  measureUnits: IMeasureUnit[];
  onSelectUnit(unit: IMeasureUnit): void;
  selected?: IMeasureUnit;
  itemMeasureUnit?: EMeasureUnit | string;
  isMultipleSelectField?: boolean;
}

const MeasureUnitSelect: React.FC<IUnitSelectProps> = ({
  measureUnits,
  onSelectUnit,
  selected,
  itemMeasureUnit,
  isMultipleSelectField
}) => {
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const updateErrorMessage = () => {
      setErrorMessage('');

      if (
        !isMultipleSelectField &&
        isSelectedAnInvalidMeasureUnit(selected, itemMeasureUnit)
      ) {
        const availableMU = measureUnits.map((mu) => mu.measure);
        setErrorMessage(
          `Este produto é vendido apenas em ${availableMU.join(',')}.`
        );
      }
    };
    updateErrorMessage();
  });

  const handlePositionChange = ([unit]: TChipArray[]) => {
    onSelectUnit(
      measureUnits.find((un) => un.measure === unit.label) as IMeasureUnit
    );
  };

  const measureUnitsValues = measureUnits.map((unit) => ({
    id: unit.measure,
    label: unit.measure
  }));

  return (
    <Tooltip
      overlayClassName="shop-cart-input-tooltip"
      placement="top"
      title={errorMessage}
      trigger={['hover', 'click']}
      color={theme.colors.red}
    >
      <Chips
        type="choice"
        chips={measureUnitsValues}
        updateChips={handlePositionChange}
        selectedChipIds={selected ? [selected.measure] : undefined}
        handleSelect={(e) => {
          if (e.length) {
            const [option] = e;
            handlePositionChange([{ id: option, label: option }]);
            return;
          }
          if (selected) {
            handlePositionChange([
              { id: selected.measure, label: selected.measure }
            ]);
          }
        }}
      ></Chips>
    </Tooltip>
  );
};

export default MeasureUnitSelect;
